<template>
  <div class="municipio">
    <div class="municipio__actions">
      <div class="municipio__actions__voltar">
        <v-btn
          type="button"
          text
          class="municipio__actions__voltar--button"
          @click="$router.push(`/cidade/${municipio.municipioId}`)"
        >
          Voltar
        </v-btn>
      </div>
      <div class="municipio__actions__adicionar">
        <v-btn
          type="button"
          class="municipio__actions__adicionar--buttonAdd"
          @click="downloadPdf"
        >
          Download Resumo
        </v-btn>
        <v-btn
          type="button"
          class="municipio__actions__adicionar--button"
          @click="
            $router.push(
              `/cidade/${municipio.municipioId}/resumo-municipio/add`
            )
          "
        >
          Adicionar
        </v-btn>
      </div>
    </div>

    <v-card elevation="2" class="municipio__header">
      <div class="municipio__header__name">{{ municipio.nome }}</div>
      <hr />
      <div class="municipio__header__contrato">
        <div class="municipio__header__contrato__periodo">
          Período contrato: {{ municipio.dataContrato }}
        </div>
        <div
          class="municipio__header__contrato__numContrato"
          v-if="municipio.numeroContrato"
        >
          Num Contr: {{ municipio.numeroContrato }}
        </div>
      </div>
    </v-card>

    <v-card elevation="2" class="municipio__body" v-if="municipioResumo.length">
      <div
        class="municipio__body__items"
        v-for="municipioResumo in municipioResumoGroupBy"
        :key="municipioResumo.resumoId"
      >
        <div class="municipio__body__items__instituicao">
          {{ municipioResumo.name }}
        </div>

        <div
          class="municipio__body__items__dados"
          v-for="municipioResumoChildren in municipioResumo.children"
          :key="municipioResumoChildren.resumoId"
        >
          <v-col class="municipio__body__items__dados__foto" cols="2">
            <img
              :src="`data:image/png;base64,${municipioResumoChildren.foto}`"
            />
          </v-col>
          <v-col class="municipio__body__items__dados__personal" cols="3">
            <div class="municipio__body__items__dados__personal__name">
              {{ municipioResumoChildren.nome }}
            </div>
            <div class="municipio__body__items__dados__personal__funcao">
              {{ municipioResumoChildren.cargo }}
            </div>
          </v-col>
          <v-col class="municipio__body__items__dados__infos" cols="5">
            <div class="municipio__body__items__dados__infos__telefone">
              telefone: {{ municipioResumoChildren.telefone }}
            </div>
            <div class="municipio__body__items__dados__infos__email">
              Email: {{ municipioResumoChildren.email }}
            </div>
          </v-col>
          <v-col class="municipio__body__items__dados__infos__actions">
            <v-btn
              outlined
              color="warning"
              class="mr-3"
              @click="
                $router.push(
                  `/cidade/${municipio.municipioId}/resumo-municipio/add/${municipioResumoChildren.resumoId}`
                )
              "
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <modal-delete
              :payload="municipioResumoChildren"
              @onDelete="loadResumoMunicipio"
            ></modal-delete>
          </v-col>
        </div>
      </div>
    </v-card>

    <v-card v-if="!municipioResumo.length" class="municipio__nenhumDado">
      Nenhum dado retornado.
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { cityAPI } from "@/modules/city";
import moment from "moment";
import modalDelete from "./modalDelete.vue";
import { resumoMunicipioApi } from "@/apis";

export default {
  components: {
    modalDelete,
  },
  data() {
    return {
      municipio: {},
      municipioResumo: [],
      municipioResumoGroupBy: [],
      municipioId: this.$route.params.id,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    downloadPdf() {
      this.setLoading(true);
      resumoMunicipioApi
        .downloadPdf(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
            "Resumo_Municipio_" +
            this.municipio.nome +
            "_" +
            moment(resp.data.contratoInicio).format("DD_MM_YYYY_HH_mm") +
            ".pdf";
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF");
        });
    },
    loadCity() {
      this.setLoading(true);

      cityAPI
        .get(this.$route.params.id)
        .then(({ data }) => {
          this.municipio = {
            ...data,
            dataContrato: ` ${moment(data.contratoInicio).format("MM/YYYY")} ${
              data.contratoFim
                ? "-" + moment(data.contratoFim).format("MM/YYYY")
                : ""
            } `,
          };
          this.loadResumoMunicipio();
        })
        .catch((resp) => {
          console.log("Erro ao obter município ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
    loadResumoMunicipio() {
      resumoMunicipioApi
        .list(this.$route.params.id)
        .then(({ data }) => {
          this.municipioResumo = data;

          let groupBy = this.municipioResumo.map((item) => {
            return {
              ...item,
              instituicao: !["MUNICIPIO", "SEBRAE"].includes(item.instituicao)
                ? "Participantes de OUTRAS INSTITUIÇÕES"
                : `Participantes do ${item.instituicao}`,
            };
          });

          let key = "instituicao";
          let aux = groupBy.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});

          this.municipioResumoGroupBy = Object.keys(aux).map((key) => {
            return {
              name: key,
              resumoId: aux[key][0].resumoId,
              children: aux[key],
            };
          });

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("Erro ao obter município ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
  },
  mounted() {
    this.loadCity();
  },
};
</script>
<style lang="scss" scoped>
.municipio {
  max-width: 932px;
  margin: 2rem auto 0px auto;
  text-transform: uppercase;

  hr {
    width: 50px;
    transform: rotate(91deg);
  }

  &__header {
    display: flex;
    background: var(--corPrimaria);
    color: #fff;
    padding: 1rem;
    align-items: center;
    &__contrato {
      &__periodo {
        color: #fff;
      }
      &__numContrato {
        color: #fff;
      }
    }
    &__name {
      padding: 0px 1rem 0px 1rem;
    }
  }
  &__body {
    padding: 1rem 0px;
    &__items {
      font-size: 14px;
      &:not(:last-of-type) {
        border-bottom: 2px solid var(--corPrimaria);
      }
      &__instituicao {
        margin: 1rem 0px;
        text-align: center;
        font-weight: bold;
      }
      &__dados {
        display: flex;
        margin-bottom: 1rem;
        justify-content: space-around;
        padding: 1rem 0;
        align-items: center;
        &:nth-child(even) {
          background: #ededed8f;
        }
        &__foto {
          display: flex;
          justify-content: center;
          img {
            width: 70px;
            border-radius: 50%;
          }
        }
        &__infos {
          &__actions {
            display: flex;
          }
        }
      }
    }
  }

  &__actions {
    display: flex;
    &__voltar {
      &--button {
        color: var(--corPrimaria);
      }
    }
    &__adicionar {
      margin-bottom: 1rem;
      display: flex;
      column-gap: 1rem;
      margin-left: auto;
      &--button {
        background-color: var(--corPrimaria) !important;
        color: #fff;
      }
      &--buttonAdd {
        border: 1px solid var(--corPrimaria) !important;
        color: var(--corPrimaria);
      }
    }
  }

  &__nenhumDado {
    text-align: center;
    padding: 1rem;
  }
}
</style>
